<template>
  <div class="allresults">
    <b-jumbotron style="margin:auto;width:50%; margin-bottom:25px" container-fluid>
      <b-form @submit="onSubmit">
        <b-form-group id="passwordgroup"
                label="Type your password">

                <b-form-input
                  type="password"
                  v-model="password">
                </b-form-input>
      </b-form-group>

  <b-button type="submit" variant="primary">Get Results</b-button>
</b-form>
  <b-button  variant="secondary" style="margin:25px" v-if="show" @click="Export">Export table</b-button>
</b-jumbotron>

<b-jumbotron  v-for="d in data">

  <b-table caption-top :items="[d]" :fields="['name','sex','birthday','num_sounds','country','lang','datetime','end_datetime','browser_name','browser_version','browser_os']">
    <template slot="table-caption">
      Personal
    </template>
  </b-table>


<b-table caption-top responsive striped hover :items="d.demos" :fields="demo_fields">
  <template slot="index" slot-scope="data">
  {{data.index + 1}}
  </template>
  <template slot="table-caption">
    Demo
  </template>
</b-table>

<b-table caption-top responsive striped hover :items="d.measurements" :fields="measurement_fields">
  <template slot="index" slot-scope="data">
  {{data.index + 1}}
  </template>
  <template slot="table-caption">
    Test
  </template>
</b-table>

</b-jumbotron>
  </div>
</template>

<script>
import { mapState } from 'vuex'
var moment = require('moment')
export default {
  name: 'allresults',
  data () { return {
      data: [],
      show: false,
      demo_fields: [
        'index',
        'time_to_sound_end',
        'time_to_last_movement',
        'time_to_click',
        'distance',
        'block_counter',
        'side',
        'figure_face_side',
        'sound',
        'time_start',
        'time_sound_end',
        'time_last_movement',
        'time_click',
        'demo',
        'demo_badpos_counter'
      ],
      measurement_fields: [
        'index',
        'time_to_sound_end',
        'time_to_last_movement',
        'time_to_click',
        'distance',
        'block_counter',
        'side',
        'figure_face_side',
        'sound',
        'time_start',
        'time_sound_end',
        'time_last_movement',
        'time_click',
        'demo',
      ],
      password: 'password'
    }

  },
  methods: {
    onSubmit(evt){
      evt.preventDefault()
      console.log(this.password)
      this.show=true
      console.log("submit")
      this.$http.post('/api/getAll',{'password':this.password}).then(
        res => {
          this.data = res.body
          for (var i = 0; i < this.data.length; i++){
            this.data[i].num_sounds = this.data[i].measurements.length
          }
        },
        res => {console.log('err')}
      )
    },
    Export(){
      console.log("export")
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";

      var data = "#;ObjectId;name;sex;birthday;num_sounds;country;language;datetime;end_datetime;browser_name;browser_version;browser_os\n"
      for (var id = 0; id < this.data.length; id++){
        data += id+1
        data += ";" + this.data[id]._id
        data += ";" + this.data[id].name
        data += ";" + this.data[id].sex
        data += ";" + this.data[id].birthday
        data += ";" + this.data[id].num_sounds
        data += ";" + this.data[id].country
        data += ";" + this.data[id].lang
        data += ";" + this.data[id].datetime
        data += ";" + this.data[id].end_datetime
        data += ";" + this.data[id].browser_name
        data += ";" + this.data[id].browser_version
        data += ";" + this.data[id].browser_os
        data += "\n"

      }
      data += "\n"
      data += "#;ObjectId;sound;side;figure_face_side;distance;time_to_sound_end;time_to_last_movement;time_to_click;time_start;time_sound_end;time_last_movement;time_click;demo;demo_badpos_counter\n"
      for (var id = 0; id < this.data.length; id++){
        for (var m = 0; m < this.data[id].demos.length; m++){
          data += id + 1
          data += ";" + this.data[id]._id
          data += ";" + this.data[id]["demos"][m].sound
          data += ";" + this.data[id]["demos"][m].side
          data += ";" + this.data[id]["demos"][m].figure_face_side
          data += ";" + this.data[id]["demos"][m].distance
          data += ";" + this.data[id]["demos"][m].time_to_sound_end
          data += ";" + this.data[id]["demos"][m].time_to_last_movement
          data += ";" + this.data[id]["demos"][m].time_to_click
          data += ";" + this.data[id]["demos"][m].time_start
          data += ";" + this.data[id]["demos"][m].time_sound_end
          data += ";" + this.data[id]["demos"][m].time_last_movement
          data += ";" + this.data[id]["demos"][m].time_click
          data += ";" + this.data[id]["demos"][m].demo
          data += ";" + this.data[id]["demos"][m].demo_badpos_counter
          data += "\n"
        }
        for (var m = 0; m < this.data[id].measurements.length; m++){
          data += id + 1
          data += ";" + this.data[id]._id
          data += ";" + this.data[id]["measurements"][m].sound
          data += ";" + this.data[id]["measurements"][m].side
          data += ";" + this.data[id]["measurements"][m].figure_face_side
          data += ";" + this.data[id]["measurements"][m].distance
          data += ";" + this.data[id]["measurements"][m].time_to_sound_end
          data += ";" + this.data[id]["measurements"][m].time_to_last_movement
          data += ";" + this.data[id]["measurements"][m].time_to_click
          data += ";" + this.data[id]["measurements"][m].time_start
          data += ";" + this.data[id]["measurements"][m].time_sound_end
          data += ";" + this.data[id]["measurements"][m].time_last_movement
          data += ";" + this.data[id]["measurements"][m].time_click
          data += ";" + this.data[id]["measurements"][m].demo
          // data += ";" + this.data[id]["demos"][m].demo_badpos_counter
          data += "\n"
        }
      }
      var blob = new Blob([data], {type: "octet/stream"}),
          url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = "soundrating3_export_" + moment().format().replace(" ","_") + ".csv";
      a.click();
      window.URL.revokeObjectURL(url);

    }
  },

  mounted () {
    ;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/AllResults.vue